import { useContext } from 'react';
import classNames from 'classnames';

import Message from 'types/Message';
import { ConfigContext } from '@providers/ConfigProvider';
import { FilesContext } from '@providers/FilesProvider';
import CheckList from '@components/atoms/CheckList';
import Typography from '@components/atoms/Typography';
import Button from '@components/atoms/Button';
import ContentBox from '@components/atoms/ContentBox';
import PersonalDataClause from '@templates/PersonalDataClause';

import classes from './ContactUsImage.module.scss';

export type Props = {
  title: Message;
  listTitle?: Message;
  buttonText?: Message;
  items: {
    id: number;
    text: Message;
  }[];
  withoutContact?: boolean;
  className?: string;
};

const ContactUsImage = ({
  buttonText,
  className,
  items,
  title,
  listTitle,
  withoutContact = false,
}: Props): JSX.Element => {
  const { contact } = useContext(ConfigContext);
  const { getPageImageConfigs } = useContext(FilesContext);

  const [contactImage] = getPageImageConfigs(['contact']);

  return (
    <div className={classNames(classes.wrapper, className)}>
      <ContentBox className={classes.image} variant="image" resolveConfig={contactImage} alt="contact office" />
      <div className={classes.secondWrapper}>
        <Typography variant="h1" renderAs="div" className={classes.title}>
          {title}
        </Typography>
        {!!listTitle && (
          <Typography variant="h2" renderAs="div" weight="700" className={classes.checkListTitle}>
            {listTitle}
          </Typography>
        )}
        <CheckList
          listStyle="unordered"
          className={classNames({
            [classes.checkListWithContact]: !withoutContact,
            [classes.checkListWithoutTitle]: !listTitle,
          })}
          color="blue"
        >
          {items.map(({ id, text }) => (
            <CheckList.Item key={id}>{text}</CheckList.Item>
          ))}
        </CheckList>
        {!withoutContact && (
          <>
            <Button className={classes.button} href={`mailto:${contact.contactEmail}`} color="tertiary" size="lg">
              {buttonText}
            </Button>
            <Typography variant="caption1" renderAs="div" className={classes.caption}>
              <PersonalDataClause />
            </Typography>
          </>
        )}
      </div>
    </div>
  );
};

export default ContactUsImage;
